import { Component } from 'react';
import PropTypes from 'prop-types';

import { hasLocationChanged } from 'apps/analytics';
import CacheableSet from 'utils/CacheableSet';
import { gtm } from 'apps/gtm/index';

const sendGraphicImpressionsToGTM = (graphicImpressions, pageType) => {
  if (!graphicImpressions.length || !pageType) {
    return;
  }

  gtm.trigger('gtm:graphicImpressions', {
    pageType,
    graphicImpressionsData: [...graphicImpressions],
  });
};

export default class GraphicImpressionsContainer extends Component {
  static propTypes = {
    location: PropTypes.object,
    children: PropTypes.node.isRequired,
  };

  static childContextTypes = {
    setPageType: PropTypes.func.isRequired,
    recordGraphicImpression: PropTypes.func.isRequired,
  };

  getChildContext() {
    return {
      setPageType: this.setPageType,
      recordGraphicImpression: this.recordGraphicImpression,
    };
  }

  componentDidMount() {
    this.sendGraphicImpressions();
  }

  shouldComponentUpdate(nextProps) {
    if (hasLocationChanged(this.props.location, nextProps.location)) {
      this.graphicImpressionSet.clear();
      this.pageType = null;

      return true;
    }

    return this.props.children !== nextProps.children;
  }

  componentDidUpdate() {
    this.sendGraphicImpressions();
  }

  componentWillUnmount() {
    this.graphicImpressionSet.clear();
  }

  setPageType = (pageType) => {
    this.pageType = pageType;
  };

  recordGraphicImpression = (graphicImpressionData) => {
    this.graphicImpressionSet.enqueue(graphicImpressionData);
  };

  sendGraphicImpressions = () => {
    const promoImpressions = this.graphicImpressionSet.popAll();

    sendGraphicImpressionsToGTM(promoImpressions, this.pageType);
  };

  graphicImpressionSet = new CacheableSet(({ id }) => id);

  render = () => this.props.children;
}
